// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__11dyT","inner":"Footer_inner__3Qdeg","nextIcon":"Footer_nextIcon__1PO-X","innerLeft":"Footer_innerLeft__3yMAa"};